import React from "react";
import { Modal, ModalBody } from "../../../libraries/reactstrap";
import DatePicker from "react-datepicker";

import { PaymentPlanSelect, DownpaymentInput } from "./PaymentPlan";
import { PaymentMethod } from "./PaymentMethod";
import { SupportingDocumentsFileSelect } from "./SupportingDocumentsFileSelect";

import "react-datepicker/dist/react-datepicker.css";

class BindRequestModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      effectiveDate: null,
      isDateValid: true,
      filesToUpload: [],
      paymentMethods: [],
      selectedPaymentPlan: null,
      selectedPaymentMethod: null,
      comments: "",
      validationStarted: false,
      downpayment: null,
      autoPay: false,
      commentsFlagged: false,
    };
  }

  static getDerivedStateFromProps(nextProps) {
    if (!nextProps.isVisible) {
      return {
        effectiveDate: null,
        isDateValid: true,
        filesToUpload: [],
        paymentMethods: [],
        selectedPaymentPlan: null,
        selectedPaymentMethod: null,
        comments: "",
        validationStarted: false,
        downpayment: null,
        autoPay: false,
        commentsFlagged: false,
      }
    }

    return null;
  }

  handleAdditionalCommentsChange = (event) => {
    this.setState({ comments: event.target.value });

    const foundFlaggedPhrase = event.target.value.match(
      /\b(credit card|cc|bank account|ach|cvv|exp date|expiration date)\b/i
    );
    const foundCreditCardNumber = event.target.value.match(/(\d[- ]*){12}/);

    this.setState({
      commentsFlagged: foundFlaggedPhrase || foundCreditCardNumber,
    });
  };

  render() {
    let generalInfo = this.props.generalInfo;

    const showDownpayment =
      generalInfo.SurplusLines !== true &&
      this.state.selectedPaymentPlan &&
      this.state.selectedPaymentPlan !== "Full Pay";

    const libertyWithCreditCard = this.props.generalInfo.CarrierId === 121
      && this.state.selectedPaymentMethod === "Credit / Debit Card";

    const totalPremium = (generalInfo.PremiumDecimal * (libertyWithCreditCard ? 1.025 : 1.0)).toLocaleString(undefined, {
      currency: "USD",
      style: "currency"
    });

    return (
      <div>
        <Modal isOpen={this.props.isVisible} style={{ maxWidth: "800px" }}>
          <ModalBody className="bind-request-modal-body">
            <div className="bind-request-header">
              {/* Could be shifted to a BindRequestInfo component */}
              <div className="bind-request-info">
                <div>
                  Client's Business Name:&nbsp;
                  <span style={{ fontWeight: "bold" }}>
                    {generalInfo.ClientBusinessName}
                  </span>
                </div>
                <div>
                  Line of Business:&nbsp;
                  <span style={{ fontWeight: "bold" }}>
                    {generalInfo.LobDescription}
                  </span>
                </div>
                <div>
                  Carrier:&nbsp;
                  <span style={{ fontWeight: "bold" }}>
                    {generalInfo.CarrierName}
                  </span>
                </div>
                <div>
                  Total Policy Premium:&nbsp;
                  <span style={{ fontWeight: "bold", color: libertyWithCreditCard ? "#ff0000" : undefined }}>
                    {totalPremium}
                    {libertyWithCreditCard && (
                      <span>
                        {" "}(2.5% credit card surcharge applied)
                      </span>
                    )}
                  </span>
                </div>
              </div>

              <div className="form-group">
                <label>Effective Date:</label>
                <DatePicker
                  filterDate={(date) => {
                    return date >= new Date(new Date().setHours(0, 0, 0, 0));
                  }}
                  selected={this.state.effectiveDate}
                  placeholderText="Set effective date"
                  onChange={(date) => {
                    if (this.onChangeRawFired) {
                      this.onChangeRawFired = false;

                      return;
                    }

                    if (
                      date === null ||
                      (date instanceof Date && !isNaN(date))
                    ) {
                      this.setState({
                        effectiveDate: date,
                        isDateValid: this.validateDate(date),
                      });
                    }
                  }}
                  onChangeRaw={(event) => {
                    if (event.type === "change") {
                      this.onChangeRawFired = true;

                      if (
                        !event.target.value.match(
                          /\d\d?[\/-]\d\d?[\/-]\d\d\d\d/
                        )
                      ) {
                        return;
                      }

                      const date = new Date(event.target.value);

                      if (
                        date instanceof Date &&
                        !isNaN(date) &&
                        date >= new Date(new Date().setHours(0, 0, 0, 0))
                      ) {
                        this.setState({
                          effectiveDate: date,
                          isDateValid: this.validateDate(date),
                        });
                      }
                    }
                  }}
                />
                <div className={this.state.isDateValid ? "hide-item" : "error"}>
                  Please enter valid date
                </div>
              </div>
              <div className="effective-date-note">
                Please note that our offices close at 5pm local time and are
                closed on Saturdays, Sundays, and Federal Holidays. If you are
                submitting a bind request after hours or over the weekend
                (including Federal Holiday) for a present effective date, please
                note that we may not be able to accommodate this date as the
                effective date is subject to carrier discretion.
              </div>

              <PaymentPlanSelect
                onChange={(plan) =>
                  this.setState({ selectedPaymentPlan: plan, downpayment: null })
                }
                error={
                  this.state.validationStarted &&
                  !this.state.selectedPaymentPlan
                }
                SurplusLines={generalInfo.SurplusLines}
              />

              {showDownpayment && (
                <DownpaymentInput
                  error={this.state.selectedPaymentPlan !== "Full Pay" &&
                    this.state.validationStarted && (this.state.downpayment === null || this.state.downpayment === "")
                  }
                  onChange={(down) => this.setState({ downpayment: down })}
                />
              )}

              <div className="form-group">
                <a href="/reference-tools/payment" target="_blank">
                  Premium Payment Information
                </a>
              </div>

              {generalInfo.SurplusLines !== true && (
                <PaymentMethod
                  carrierId={this.props.generalInfo.CarrierId}
                  paymentMethod={this.state.selectedPaymentMethod}
                  onChange={(method) =>
                    this.setState({ selectedPaymentMethod: method })
                  }
                  error={
                    this.state.validationStarted &&
                    !this.state.selectedPaymentMethod
                  }
                />
              )}

              {generalInfo.SurplusLines !== true &&
                this.state.selectedPaymentPlan &&
                this.state.selectedPaymentPlan !== "Full Pay" && (
                  <div>
                    <label>Auto-Pay: </label>
                    <input
                      type="checkbox"
                      style={{ marginLeft: "10px" }}
                      name="autoPay"
                      checked={this.state.autoPay}
                      onClick={() =>
                        this.setState({ autoPay: !this.state.autoPay })
                      }
                    />
                    <p style={{ fontStyle: "italic" }}>
                      I have obtained the customer’s consent to set up
                      electronic fund transfers for future premium payments. I
                      acknowledge that I have obtained the appropriate
                      documentation signed by the customer and will retain
                      copies as evidence of consent.
                    </p>
                  </div>
                )}

              <SupportingDocumentsFileSelect
                value={this.state.filesToUpload}
                onChange={(files) => this.setState({ filesToUpload: files })}
              />

              <div
                className="form-group"
                style={{ width: "auto", minWidth: 480 }}
              >
                <label>
                  Additional Comments:{" "}
                  <span style={{ color: "red" }}>
                    Do not add payment information
                  </span>
                </label>
                <textarea
                  placeholder="E.g. Placeholder text"
                  onChange={this.handleAdditionalCommentsChange}
                />
                {this.state.commentsFlagged && (
                  <div
                    style={{
                      marginTop: -10,
                      marginBottom: 10,
                      color: "red",
                    }}
                  >
                    It appears you are entering payment information. Please
                    review before submitting.
                  </div>
                )}
              </div>
            </div>
            <span>
              <b>Confirm Terms and Conditions:</b>
            </span>
            <div
              dangerouslySetInnerHTML={{
                __html: this.props.generalInfo.BindTerms,
              }}
              className="bind-terms"
            />
            <div className="bind-request-footer">
              <button
                id="cancel-bind-request"
                className="btn btn-default"
                onClick={() => this.props.closeBindRequestModal()}
              >
                Cancel
              </button>
              <button
                id="submit-bind-request"
                className="btn btn-primary"
                disabled={this.state.commentsFlagged}
                onClick={() => {
                  this.props.generalInfo.SurplusLines === true
                    ? this.submitSurplusBindRequest()
                    : this.submitBindRequest();
                }}
                style={{ color: "white" }}
              >
                Submit Bind Request
              </button>
            </div>
          </ModalBody>
        </Modal>
      </div>
    );
  }

  submitBindRequest() {
    if (this.validatePaymentRequest()) {
      this.props.onApplyBindRequest({
        effectiveDate: this.state.effectiveDate,
        files: this.state.filesToUpload,
        comments: this.state.comments,
        plan: this.state.selectedPaymentPlan,
        downpayment: this.state.downpayment,
        method: this.state.selectedPaymentMethod,
        lob: this.props.generalInfo.LobDescription,
        quoteId: this.props.generalInfo.Id,
        policyQuoteId: this.props.generalInfo.PolicyQuoteId,
        carrier: this.props.generalInfo.CarrierName,
        clientId: this.props.generalInfo.ClientId,
        autoPay: this.state.autoPay,
      });
      this.props.history.push("/collect-payment");
    }
  }

  submitSurplusBindRequest() {
    if (this.validateSurplusBindRequest()) {
      this.props.onApplyBindRequest({
        effectiveDate: this.state.effectiveDate,
        files: this.state.filesToUpload,
        comments: this.state.comments,
        plan: this.state.selectedPaymentPlan,
        policyQuoteId: this.props.generalInfo.PolicyQuoteId,
        autoPay: this.state.autoPay,
        clientId: this.props.generalInfo.ClientId,
      });
      this.props.history.push("/submit-surplus-bind");
    }
  }

  validatePaymentRequest() {
    const isDateValid = this.validateDate(this.state.effectiveDate);

    this.setState({ isDateValid: isDateValid, validationStarted: true });

    return (
      isDateValid &&
      this.state.selectedPaymentPlan &&
      this.state.selectedPaymentMethod && (
        this.state.selectedPaymentPlan === "Full Pay" ||
        !(this.state.downpayment === null || this.state.downpayment === "")
      )
    );
  }

  validateSurplusBindRequest() {
    const isDateValid = this.validateDate(this.state.effectiveDate);

    this.setState({ isDateValid: isDateValid, validationStarted: true });
    return isDateValid && this.state.selectedPaymentPlan;
  }

  validateDate(date) {
    return date !== null;
  }
}

export default BindRequestModal;
